











// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/forfait/edit/EditPiscine.vue'
import { getDefaultAloForfait, AloForfait } from '@/models/alo/AloForfait'
import { toStringDictionary } from '@/utils/groupBy'
import ListeTuilePres from '@/components/shared/ListeTuilePres.vue'
import { ITuileNav } from '@/models/ui/ITuileNav'
import { getImageUrl } from '@/utils/images'

@Component({
  name: 'ReadPiscine',    
   props: {
    forfait:{      
      default:getDefaultAloForfait()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ListeTuilePres}
})
export default class ReadActivity extends Vue {
  private forfait!:AloForfait
  private loading!:boolean

  get piscineDic(){
    return this.$store.myGetters.piscineDic
  }
  
  

  get piscineTuileList(){
    return this.forfait.psnIds.filter(psnId => !!this.piscineDic[psnId]).map(id => {
      return { 
        id: id,  
        title: this.piscineDic[id]?.libelle,
        image: this.piscineDic[id]?.image,
        subtitle: this.piscineDic[id]?.content?.pctSubTitle,
        promo: this.piscineDic[id].psnDomicile?null:this.piscineDic[id]?.address?.libelle
      } as ITuileNav
    })
  }

  get configuration(){
    return this.$store.myGetters.configuration
  }

  created(){
    this.$store.myActions.ADM_PISCINE_ENSURE()
  }

  edit() { (this.$refs.edit as Edit).edit(this.forfait) }
}
